<template>
  <ion-page>
    <ion-tabs animation>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar style="border-top: unset" color="custom-white" slot="bottom" class="py-2 bottombar-shadow">
        <!-- <ion-tab-button :class="($route.name == 'dashboard') ? selected : unselected" tab="dashboard"
          href="/root/dashboard">
          <mdicon name="monitor-dashboard" />
          <ion-label style="font-size:12px">
            Dashboard
          </ion-label>
        </ion-tab-button> -->

        <!-- inspections -->
        <ion-tab-button :class="($route.name == 'inspections-list') ? selected : unselected" tab="inspections"
          @click="toInspections()">
          <mdicon name="account-hard-hat-outline" />
          <ion-label style="font-size: 12px"> Inspecties </ion-label>
        </ion-tab-button>

        <ion-tab-button tab="new" @click="actions()">
          <mdicon name="card-plus-outline" />
          <ion-label style="font-size: 12px"> Nieuw </ion-label>
        </ion-tab-button>

        <ion-tab-button v-if="$store.getters.checkSetting('ohmi')"
          :class="($route.name == 'ohmi') ? selected : unselected" tab="ohmi" @click="openOhmi()">
          <mdicon name="robot-outline" />
          <ion-label style="font-size:12px">
            Ohmi
          </ion-label>
        </ion-tab-button>

        <ion-tab-button :class="$route.name == 'account' ? selected : unselected" tab="account" href="/root/account">
          <mdicon name="account-circle-outline" />
          <ion-label style="font-size: 12px">Account</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>F
    <global-actions-sheet ref="globalActionsSheet"></global-actions-sheet>
  </ion-page>
</template>

<script lang="js">
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonPage, IonRouterOutlet, modalController } from '@ionic/vue';
import GlobalActionsSheet from '../../components/GlobalActionsSheet.vue';
import Assistant from '../../components/Assistant.vue';

export default {
  name: 'TabsPage',
  components: { IonLabel, IonTabs, IonTabBar, IonTabButton, IonPage, IonRouterOutlet, GlobalActionsSheet },
  data() {
    return {
      selected: 'tab-selected ios tab-has-label tab-has-label-only tab-layout-icon-top ion-activatable ion-selectable ion-focusable text-primary',
      unselected: 'ios tab-has-label tab-has-label-only tab-layout-icon-top ion-activatable ion-selectable ion-focusable',
      use_ohmi: false,
    }
  },
  created() {
  },
  methods: {
    toInspections() {
      this.$router.replace({ name: 'inspections' });
    },
    actions() {
      this.$refs.globalActionsSheet.actions();
    },
    openOhmi() {
      const modal = modalController.create({
        component: Assistant,
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        props: {
          mode: 'conversation_mode'
        }
      });

      modal.then((modal) => {
        modal.present();
      });

    },
  },
};
</script>
